export default __webpack_public_path__ + "static/media/cross-dark.1c784329.svg";